import { request } from "@weapp/utils";
import { getTokenStorage, encryptRsa, getCookie, passportHost } from "../../utils";
import { publicUrlapi } from "../../constants";

// 邮箱是否被占用
export const validateEmail = (email: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/validateEmail?emailAccount=${email}`,
    method: "POST"
  });
};
// 国外手机校验
export const getForeignGraphCode = () => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/getCommonCode?userIdToken=${getTokenStorage()}`,
    method: "GET",

  });
};
// demo登录
export const logoDemo = () => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/login/logindemo`,
    method: "GET"
  });
};
// 手机是否被占用
export const validateMobile = (params: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/validateInternationalMobile`,
    method: "POST",
    params
  });
};
//注册
export const sign = (params: any) => {
  // 暂时注释
  params = encryptRsa(params, 'password');
  params.passwordCheck = params.password;
  // params = encryptRsa(params, 'passwordCheck');
  let url = `${passportHost()}${publicUrlapi}/papi/passport/signup/register?service=${encodeURIComponent(window.location.href)}`
  if (params.codeValid) {
    url += '?codeValid=' + params.codeValid;
    delete params.codeValid;
  }
  return request({
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      "langType": getCookie('langType') || 'zh_CN'
    },
    url: url,
    method: "POST",
    data: params
  });
};

//判断是否显示跳过验证
export const qryDumpAccountVaild = () => {
  return request({
    url: '/papi/passport/info/qryDumpAccountVaild',
    method: 'get',
  })
}

// 跳过验证
export const skipValidate = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/skipAccountCheck`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};
// 发送验证码
export const sendMobileCode = (params: any) => {
  const formData = new FormData();
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      formData.append(key, params[key]);
    }
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/sendMobileCode`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};
// 校验发送验证码
export const checkMobileCode = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/checkMobileNext`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};
// 发送激活邮件
export const sendEmail = () => {
  const formData = new FormData();
  formData.append("userIdToken", getTokenStorage());
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/signup/sendEmail`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "langType": getCookie('langType') || 'zh_CN'
    },
    method: "POST",
    data: formData
  });
};

// 邮箱激活链接回调
